export default "/images/d8b44144636f6bcf426ca03af31ce54f.jpg";